export default __webpack_public_path__ + "static/media/witnesses-1.ba4f3332.jpg";